// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__K6YWz","text":"styles_text__GyMKL","cta":"styles_cta__MZ20t","longCaption":"styles_longCaption__8SIT3"};